import React from 'react';
import Layout from "../components/App/Layout"
import SEO from "../components/App/SEO"
import NavbarStyleTwo from '../components/App/NavbarStyleTwo';
import PageBanner from '../components/Common/PageBanner';
import Footer from '../components/App/Footer';

import StartProjectWithUs from '../components/Common/StartProjectWithUs';

import ChatServicesImg1 from '../assets/images/conversational-ai/1.png'
import ChatServicesImg2 from '../assets/images/conversational-ai/2.png'
import ChatServicesImg3 from '../assets/images/conversational-ai/3.png'


const SingleServices = () => {
    return (
        <Layout>
            <SEO title="Conversational AI - Chatbots & Voice Assistants" description="Craft meaningful customer experiences that drive RoI with the help of AI powered chatbots. Our advanced nlp engines are built to power bot experiences in multiple languages across multiple channels."/>

			<NavbarStyleTwo />

			<PageBanner 
                pageTitle="Conversational AI" 
            /> 

<div className="overview-area ptb-100">
                <div className="container">
                    <div className="overview-box">
                        
                    <div className="overview-content">
                            <div className="content right-content">
                                <span className="sub-title">Deliver the Perfect Customer Experience</span>
                                <h2>Design AI-powered Chatbots</h2>
                                <p>Start your CX automation journey with the help of AI powered chatbots. Design bots that deliver value from the moment they go live.</p>
                                <ul className="features-list">
                                    <li><span><i className='bx bx-check'></i> Intelligent Virtual Assistants</span></li>
                                    <li><span><i className='bx bx-check'></i> Contextual Chatbots</span></li>
                                    <li><span><i className='bx bx-check'></i>Natural Language Understanding Engine</span></li>

                                </ul>
                            </div>
                        </div>

                        <div className="overview-image">
                            <div className="image">
                                <img src={ChatServicesImg1} alt="Cimplify Chatbots" />
                            </div>
                        </div>
                    </div>

                    <div className="overview-box">
                        <div className="overview-image">
                            <div className="image">
                                <img src={ChatServicesImg2} alt="Cimplify Multichannel and Multilingual Chatbots" />
                            </div>
                        </div>
                        
                        <div className="overview-content">
                            <div className="content right-content">
                                <span className="sub-title">Become Omnipresent with AI</span>
                                <h2>Deploy One Version. For All Channels.</h2>
                                <p>Build a bot for one channel and easily scale to all other channels including voice and chat. End-to-end support for multichannel and multilingual implementation.</p>
                                <ul className="features-list">
                                    <li><span><i className='bx bx-check'></i> Omnichannel Orchestration</span></li>
                                    <li><span><i className='bx bx-check'></i> Deploy on Whatsapp, Website, SMS, Telegram, Messenger, Alexa & more </span></li>
                                    <li><span><i className='bx bx-check'></i> Multiple Language Support</span></li>
                                    <li><span><i className='bx bx-check'></i> Webhooks & API</span></li>
                                
                                    

                                </ul>
                            </div>
                        </div>
                        <div className="overview-box">
                        
                        <div className="overview-content">
                                <div className="content right-content">
                                    <span className="sub-title">Complete control over conversations</span>
                                    <h2>Add a Human Element</h2>
                                    <p>Transition conversations from bot to human when the conversations gets too complicated. Easily monitor and manage all human-to-human conversations with a single interface.</p>
                                    <ul className="features-list">
                                        <li><span><i className='bx bx-check'></i> Human-in-the-Loop for handoff</span></li>
                                        <li><span><i className='bx bx-check'></i> Single User Interface to manage cross-channel communication </span></li>
                                        <li><span><i className='bx bx-check'></i> Conversation Analytics</span></li>
                               

                                    </ul>
                                </div>
                            </div>
    
                            <div className="overview-image">
                                <div className="image">
                                    <img src={ChatServicesImg3} alt="Cimplify Human Handoff for Chatbots" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="services-area bg-f9f9f9 pt-100 pb-70">
                <div className="container">
                    <div className="section-title">
                        <span className="sub-title">CRAFTING ENGAGING CONVERSATIONS</span>
                        <h2>Core Application Areas</h2>
                        <p>Here are a few areas where Conversational AI can be used to improve efficiency and drive productivity.</p>
                    </div>

                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-mobile-vibration"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Sales & Marketing</h3>
                                <p>Lead generation, shopping assistance, dynamic product discovery, product recommendation, product review solicitation & more.</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-chat"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Customer Support</h3>
                                <p>Automated problem resolution, ticket generation, CSAT measurement, product usage assistance, project guides & more.</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-calendar-plus"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Event Scheduling</h3>
                                <p> Create calendar events in any chat environment by simply conversing with the scheduler bot and receive prompt notifications.</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-bookmarks"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Ticket/Appointment Booking</h3>
                                <p>Use a chatbot to manage medical appointments, salon and spa appointments, movie tickets, concert tickets, match tickets & much more.</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-cart-alt"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Online Shopping</h3>
                                <p>Shopping assistance, abandoned cart recovery, product recommendation, promote offers, up-selling and cross-selling opportunities, & more.</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-money"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Billing & Collections</h3>
                                <p> Invoice generation, payment reminders, receipt generation, customer's statement of accounts, historical receipts & more.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

          
            
            <StartProjectWithUs />
			  
			<Footer />
		</Layout>
    )
}

export default SingleServices;